import React from 'react';
import { renderCheckboxGroup as RenderCheckboxGroup } from 'components/form/field/redux-field';
import useProvider from 'hooks/useProvider';

export default ({ providers, field, label, input, meta, disabled, labelSize, qaId }) => {
  const fields = useProvider(providers, field.provider, []);

  return (
    <RenderCheckboxGroup
      label={label}
      input={input}
      meta={meta}
      disabled={disabled}
      labelSize={labelSize}
      qaId={qaId}
      fields={fields}
    />
  );
};
